import { render, staticRenderFns } from "./EditNormalizedScoresFunctions.vue?vue&type=template&id=00587f1a&"
import script from "./EditNormalizedScoresFunctions.vue?vue&type=script&lang=ts&"
export * from "./EditNormalizedScoresFunctions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports